<template>
  <div>
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="green"
    ></v-progress-circular>
    <div v-else id="paypal-button-container"></div>
  </div>
</template>

<script>
import { loadScript } from '@paypal/paypal-js';
import Axios from 'axios';
import { paypalConfig, cloudFunctions } from '../../config.js';

export default {
  name: 'paypal-standard',

  props: {
    payButtonEnabled: {
      type: Boolean,
      default: false,
    },
    orderedItem: {
      type: Object,
      default: () => {},
    },
    customerData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      paypay: null,
      loading: false,
    };
  },

  mounted() {
    loadScript({
      clientId: paypalConfig.clientId,
      currency: 'EUR',
      components: 'buttons,funding-eligibility',
    })
      .then((paypal) => {
        const ordered = this.orderedItem;
        const customer = this.customerData;
        const emit = this.emitPaymentCompleted;
        this.createButton(emit, paypal, paypal.FUNDING.PAYPAL, ordered, customer);
      })
      .catch((error) => {
        console.log('failed to load Paypal SDK', error);
      });
  },

  methods: {
    emitPaymentCompleted(transaction) {
      this.$emit('payment-successful', {
        paidPlan: this.orderedItem,
        paymentId: transaction,
        paidBy: 'paypal',
      });
    },

    createButton(emit, paypal, fundingSource, ordered, customer) {
      const config = {
        fundingSource,
        createOrder() {
          return Axios({
            url: `${cloudFunctions}/paypalCreateOrder`,
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
            data: JSON.stringify({ orderedItem: ordered, customerData: customer }),
          })
            .then((response) => response.data)
            .then((order) => order.id);
        },
        // Finalize the transaction after payer approval
        onApprove(data) {
          return Axios({
            url: `${cloudFunctions}/paypalCapturePayment`,
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
            data: JSON.stringify({
              orderID: data.orderID,
            }),
          })
            .then((response) => response.data)
            .then((orderData) => {
              // console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
              const transaction = orderData.purchase_units[0].payments.captures[0];
              emit(transaction);
            });
        },
      };

      const button = paypal.Buttons(config);
      if (button.isEligible()) {
        button.render('#paypal-button-container');
      }
    },
  },
};
</script>
